module.exports = __webpack_public_path__ + "assets/img/field.65447095.webp";